import { lazy, Suspense } from "react";
import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Analytics } from "@vercel/analytics/react";
import { SEO_ROUTES } from "@/config/seo-routes";
import Index from "./pages/Index";
const GeneraPage = lazy(() => import("./pages/GeneraPage"));

const QrCodeWhatsApp = lazy(() => import("./pages/seo/QrCodeWhatsApp"));
const QrCodeWifi = lazy(() => import("./pages/seo/QrCodeWifi"));
const QrCodeInstagram = lazy(() => import("./pages/seo/QrCodeInstagram"));
const QrCodePdf = lazy(() => import("./pages/seo/QrCodePdf"));
const QrCodeMenuRistorante = lazy(() => import("./pages/seo/QrCodeMenuRistorante"));
const CosEUnQrCode = lazy(() => import("./pages/seo/CosEUnQrCode"));
const QrCodeDinamicoVsStatico = lazy(() => import("./pages/seo/QrCodeDinamicoVsStatico"));
const ComeCreareQrCodeConLogo = lazy(() => import("./pages/seo/ComeCreareQrCodeConLogo"));
const QrCodeBigliettiDaVisita = lazy(() => import("./pages/seo/QrCodeBigliettiDaVisita"));
const QrCodeEventi = lazy(() => import("./pages/seo/QrCodeEventi"));
const NotFound = lazy(() => import("./pages/NotFound"));

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <Toaster />
      <Sonner />
      <BrowserRouter>
        <Suspense fallback={<div className="min-h-screen bg-background flex items-center justify-center" aria-live="polite" />}>
        <Routes>
          <Route path={SEO_ROUTES.home} element={<Index />} />
          <Route path={SEO_ROUTES.generator} element={<GeneraPage />} />
          <Route path="/genera" element={<Navigate to={SEO_ROUTES.generator} replace />} />
          <Route path={SEO_ROUTES.whatsapp} element={<QrCodeWhatsApp />} />
          <Route path={SEO_ROUTES.wifi} element={<QrCodeWifi />} />
          <Route path={SEO_ROUTES.instagram} element={<QrCodeInstagram />} />
          <Route path={SEO_ROUTES.pdf} element={<QrCodePdf />} />
          <Route path={SEO_ROUTES.menuRistorante} element={<QrCodeMenuRistorante />} />
          <Route path={SEO_ROUTES.cosEUnQrCode} element={<CosEUnQrCode />} />
          <Route path={SEO_ROUTES.qrCodeDinamicoVsStatico} element={<QrCodeDinamicoVsStatico />} />
          <Route path={SEO_ROUTES.qrCodeConLogo} element={<ComeCreareQrCodeConLogo />} />
          <Route path={SEO_ROUTES.qrCodeBigliettiDaVisita} element={<QrCodeBigliettiDaVisita />} />
          <Route path={SEO_ROUTES.qrCodeEventi} element={<QrCodeEventi />} />
          {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
          <Route path="*" element={<NotFound />} />
        </Routes>
        </Suspense>
      </BrowserRouter>
      <Analytics />
    </TooltipProvider>
  </QueryClientProvider>
);

export default App;
